import { TOAST } from '@commoncore/constants/ToastMessages';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { UPLOAD_CONS } from '@core/constants/UploadConstants';
import { Subscription } from 'rxjs';
import { USER_DETAILS } from '../constants/Constants';
import { UploadFileImplementation } from './UploadFileImplementation';
import { UploadFolderImplementation } from './UploadFolderImplementation';
import { UploadUtility } from './UploadUtil';
var SparkMD5 = require('spark-md5');  
declare var ProgressBar: any;

export class UploadQueueImpl {

  public uploadQueue: any = [];

  public failedUploads: any = [];

  protected http: any;
  protected connectionService: any;
  protected router: any;
  protected universalService: any;
  static singleInstance: any;
  localStorageService: any;
  uploadFileImpl: any;
  uploadFolderImpl: any;
  uploadInprocess: any = false;

  public uploadStarted: boolean= false;
  public uploadCompleted:any = false;
  public totalRemainingBytes:any;
  public static timeLeftToFinishUpload: string = "";
  public static commonReadRate:any = 0; // 
  public static commonLargeFileUploadRate:any = 0;
  public static commonSmallFileUploadRate:any = 0;
  protected timeRemaining: string = "";
  protected totalFilesSize: number = 0;
  protected totalUploadedBytes:any;
  public storageFullErrorAlreadyShown:boolean = false;
  public closeProgressBarInterval:any; 
  public isRetryAll:boolean = false;
  public cancelAll: boolean = true;
  processingIndex:any;
  popTypeDuringUpload:any = "";
  notAllowedExt:any;
  uploadUtil: UploadUtility;
  constructor(protected globalService) {
    this.initializeProperties()

  }

  initializeProperties() {
    this.http = this.globalService.getHttpClientRef();
    this.connectionService = this.globalService.getConnectionSvcRef();
    this.router = this.globalService.getRouterRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    this.uploadFileImpl = UploadFileImplementation.getInstance(this.globalService);
    this.uploadFolderImpl = UploadFolderImplementation.getInstance(this.globalService);
    this.notAllowedExt = UPLOAD_CONS.FILE_FORMATS['NOTALLOWED'];
    this.uploadUtil = UploadUtility.getInstance(this.globalService);
  }

  public static getInstance(globalService): UploadQueueImpl { 
    if (this.singleInstance == null) {
      this.singleInstance = new UploadQueueImpl(globalService);
      this.singleInstance.registeringEvents()
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }
  
  private registeringEvents(){
    AppEvents.globalObservable.subscribe(response => { 
      if(response["closeAll"]) return;
      if(response["duplicateFolder"]){
        this.popTypeDuringUpload = "duplicateFolder";
        this.processingIndex = response["queueIndex"]
        return;
      }
      
    })
  }

  public initAllUploadParams(){
    this.universalService.MarkNewObjArray = [];
    this.totalFilesSize = 0;
    this.totalUploadedBytes = 0;
    this.failedUploads = [];
    this.totalRemainingBytes = 0;
    UploadQueueImpl.timeLeftToFinishUpload = "";
    this.timeRemaining = "";    
    this.uploadQueue = [];
    this.uploadStarted = false;
    this.totalFilesSize = 0;
    this.cancelAll = true;
    this.isRetryAll = false; 
    this.popTypeDuringUpload = "";
    this.uploadCompleted = false;
  }

  public initiateUpload(files, dataToUpload, uploadParams) {
    let classRef = this;
    let dataPushed = 0;
    // if(this.uploadCompleted){
    //   this.initAllUploadParams();
    // }
    let existingIndex = classRef.uploadQueue.length;
    dataToUpload.forEach((file, index) => {
      if(classRef.notAllowedExt.indexOf(file["name"].toLowerCase()) == -1){
        Object.assign(file, uploadParams);
        classRef.setFileProperties(file);
        file.waiting = true;
        file.isFile = true;
        file.index = existingIndex + index;
        file.currentFolderKey = uploadParams.currentFolderKey;
        classRef.setUiEffects(file);
        classRef.uploadUtil.fileProgressUI(file,true);
        dataPushed = 1
        classRef.uploadQueue.push(file);
      }
    });
    if(dataPushed == 1){
      this.uploadStarted = true;
      this.uploadCompleted = false;
      classRef.startUpload(existingIndex)
    }
    
  }

  public async initiateFolderUpload(files, dataToUpload, uploadParams) {
    let classRef = this;
    // if(this.uploadCompleted){
    //   await this.initAllUploadParams();
    // }
    let existingIndex = classRef.uploadQueue.length;
    dataToUpload.forEach((file, index) => {
        Object.assign(file, uploadParams);
        classRef.setFolderProperties(file);
        file.waiting = true;
        file.isFile = false;
        file.index = existingIndex + index;
        file.currentFolderKey = uploadParams.currentFolderKey;
        classRef.setUiEffects(file)
        classRef.uploadUtil.fileProgressUI(file,true);
        classRef.uploadQueue.push(file);
    });
    this.uploadStarted = true;
    this.uploadCompleted = false;
    classRef.startUpload(existingIndex)
  }

  public async initiateDroppableUpload(files, dataToUpload, uploadParams) {
    let classRef = this;
    let dataPushed = 0;
    let albumFolderErrorShown = false;
    // if(this.uploadCompleted){
    //   await this.initAllUploadParams();
    // }
    let existingIndex = classRef.uploadQueue.length;
    const droppedItemsCount = files.length
    for( let j=0; j< droppedItemsCount; j++){
        let obj = files[j];
        if(obj.IsFolder == true && classRef.universalService.isAlbumsView ) {
          if(this.uploadStarted){
            this.uploadStarted = false
          }
          if(!albumFolderErrorShown){
            classRef.universalService.showToast(TOAST["FOLDER_UPLOAD_NOT_SUPPORTED_ALBUMS"], 'error') // 
          }
          albumFolderErrorShown = true;
          continue;
        }
        if(!obj.IsFolder) {
          console.log("object is file")
          if (obj.type == "") {
          //  obj.type = "application/executable"
          }
          obj.isFile = true;
          classRef.setFileProperties(obj);
        }
        Object.assign(obj, uploadParams);
        obj['index'] = classRef.uploadQueue.length;
        if(classRef.notAllowedExt.indexOf(obj["name"].toLowerCase()) == -1){
          dataPushed = 1;
          classRef.uploadQueue.push(obj);
        }
        classRef.setUiEffects(obj)
        classRef.uploadUtil.fileProgressUI(obj,true);
        if(obj.IsFolder == true) {
          classRef.setFolderProperties(obj);
          if(!obj["uploadFromButtonClick"]){
            obj.newName = obj.name;
            // new Promise( async (resolve, reject) => {
            //   await classRef.getFilesCountAndSize(obj,filesAndDirectories[j],resolve, reject)
            // })
              await classRef.countCalculation(obj,dataToUpload[j],j);
              /*
              .then(res =>  {
                
              }
            );*/
          }else{
            //classRef.startButtonClickFolderUpload(this.uploadQueue,j)
          }
          obj.isFile = false;
        }
    }
    if(dataPushed == 1){
      classRef.uploadStarted = true;
      classRef.uploadCompleted = false;
      classRef.startUpload(existingIndex)
    }
  }

  async startUpload(index) {
    let classRef = this;
    if (classRef.uploadInprocess) {
      return;
    } else {
      classRef.uploadInprocess = true;
      let result;
      await new Promise(async (resolve, reject) => {
        if(this.uploadQueue[index].isFile){
          result = await classRef.uploadFileImpl.uploadFile(this.uploadQueue[index], this.uploadQueue[index].folderKey, index, false,this.uploadQueue[index],resolve,this.uploadQueue)
        }else{
          this.processingIndex = index;
          this.popTypeDuringUpload = "";
          result = await classRef.uploadFolderImpl.startFolderUpload(this.uploadQueue[index], index,resolve,this.uploadQueue)
        }
      })
      classRef.uploadInprocess = false;
      if(this.uploadQueue[index].isError && !this.uploadQueue[index].mergeWaiting){
        this.addtoFailedUploadList(this.uploadQueue[index])
      }else if(!this.uploadQueue[index].isError && !this.uploadQueue[index].mergeWaiting){
        this.removeFromFaileduploadArray(this.uploadQueue[index])
      } 
      
      if(!this.uploadQueue[index].mergeWaiting){
        classRef.next(index)
      }
    }
  }

  async startFolderUpload(currentindex) {
    let classRef = this;
    if (classRef.uploadInprocess) {
      return;
    } else {
      classRef.uploadInprocess = true;
      let result = await classRef.uploadFolderImpl.startFolderUpload(this.uploadQueue[currentindex], currentindex)
      classRef.uploadInprocess = false;
      if (result) {
        classRef.next(currentindex)
      }
    }
  }

  async next(currentindex) {
    let index = this.fetchNextIndex(currentindex)
    let isFolder: boolean = false;
    isFolder = this.uploadQueue[currentindex].isFile == false ? true : false;
    if(index>-1)
     this.startUpload(index)
    else {// if (this.isUploadQueueEmpty()) 
      this.uploadCompleted = true;
      UploadQueueImpl.timeLeftToFinishUpload = "";
      this.universalService.uploadCompleted = this.uploadCompleted;
      //this.db.clearStore("RecentFilesMetadata");
      this.totalRemainingBytes = 0;
      this.cancelAll = false;
      this.isRetryAll = this.isMoreThanOneFileToRetry();
      // if (!this.isRetryAll) {
      //   this.isRetryAll = false;
      // }
      //this.minimizeProgressBar();
      this.getUploadNotification(isFolder);
      this.resetUploadParams();
      if(this.universalService.currentTab == "allfiles")
        AppEvents.emit(EventsList.UPDATE_RECENT);
      if(this.universalService.listView && !this.universalService.isMobileDevice)
        AppEvents.emit(EventsList.UPLOAD_COMPLETED);
      
      this.universalService.uploadStorageFullError = false;
      this.storageFullErrorAlreadyShown = false;
    }
  }
  minimizeProgressBar() {
    setTimeout(function() {
      const event = new Event('click');
      let el = document.getElementById('collapse_btn')
      if(el){
        el.dispatchEvent(event);
      }
    }, UPLOAD_CONS.PRGBAR_CLOSE_DELAY); 
  }
  public getUploadNotification(isFolder: boolean = false) {
    this.totalRemainingBytes = 0;
    let uploadStatusCount = this.getUploadedFilesCount();
    const successCount = uploadStatusCount.uploadCount;
    const failedCount = uploadStatusCount.failedUpload;
    if (successCount.total != 0 && failedCount.total == 0) {
      this.showfileUploadNotification(uploadStatusCount,successCount, isFolder)
      //this.closeProgressBar();
    }
    else if (successCount.total != 0 && failedCount.total != 0) {
      this.showFailedNotificationMessage(uploadStatusCount, successCount, failedCount)
    }
  }

  public resetUploadParams() {
    this.universalService.uploadStorageFullError = false;
    this.totalFilesSize = 0;
    this.totalUploadedBytes = 0;
    // this.failedUploads = [];
    this.totalRemainingBytes = 0;
    UploadQueueImpl.timeLeftToFinishUpload = "";
    this.timeRemaining = "";
  }

  private getUploadedFilesCount() {
    var allFromSameFolder = true;
    this.uploadQueue.map(file=>{
      if(file.currentFolderKey != this.uploadQueue[0]["currentFolderKey"]){
        allFromSameFolder = false; 
      }
    })
    
    let count = {
     uploadCount: {total:0, file: 0, folder:0}, 
     failedUpload: {total:0, file: 0, folder:0},
     allFromSameFolder : allFromSameFolder,
     uploadedFolderName : allFromSameFolder ? ( this.uploadQueue[0]["currentFolderName"] ? this.uploadQueue[0]["currentFolderName"] : this.uploadQueue[0]["boardName"]) : "",
     uploadedFolderKey : allFromSameFolder ? this.uploadQueue[0]["currentFolderKey"] : "",
     locationOfUpload : allFromSameFolder ? this.uploadQueue[0]["locationOfUpload"] : "",
    }

    this.uploadQueue.forEach((file) => {
      if (file.uploadDone && !file.isError) {
        if(file.isFile){
          count.uploadCount.file++
        }
        else{
          count.uploadCount.folder++;
        }
        count.uploadCount.total++;
      }
      if (file.isError && !file.uploadDone) {
        if(file.isFile){
          count.failedUpload.file++
        }
        else{
          count.failedUpload.folder++
        }
        count.failedUpload.total++;
      }
    })
    return count;
  }

  public showfileUploadNotification(uploadCount , itemLen, isFolder) {
    let classRef = this
    let itemStr = '';
    let filestring:string = '';
    let folderstring = '';
    let msg:string = '';
    let destinationFolderName:string = '';
    classRef.universalService.uploadStorageFullError = false;
    if(uploadCount["uploadedFolderName"] != ""){
      if(uploadCount["uploadedFolderName"] == 'JioCloud'){
        destinationFolderName = " to '" + "JioAICloud" + "'";
      }else{
        destinationFolderName = " to '" + uploadCount["uploadedFolderName"] + "'";
      }
    }
   
    if(itemLen.file>0){
    
      filestring = itemLen.file>1 ? 'files' : 'file';
      itemStr = filestring;
    }
    if(itemLen.folder>0){
    
      folderstring = itemLen.folder>1 ? 'folders' : 'folder' ;
      itemStr = folderstring; 
    }    
    if((itemLen.file == itemLen.total) || (itemLen.folder == itemLen.total)){
      msg = `${itemLen.total} ${itemStr} uploaded successfully${destinationFolderName}.`;
    }
    else if( itemLen.folder + itemLen.file == itemLen.total ){
      msg = `${itemLen.total} item(s) uploaded successfully${destinationFolderName}.`;
    }

    if(this.router.url.includes("/home")){
      if(itemLen.total > 1)
        msg = msg + " These can be accessed on 'My Files' page."
      else 
        msg = msg + " This can be accessed on 'My Files' page."

    }

    if(this.router.url.includes('allfiles')){
      this.universalService.showViewButton = true;
    }
    this.universalService.showViewButton = false;
    setTimeout(()=>{
      classRef.universalService.showViewButton = (this.universalService.allowUpload && !classRef.universalService.fetchAllRecentFiles) ? true : false;
        if((uploadCount["allFromSameFolder"] && (classRef.router.url.includes('allfiles') || classRef.router.url.includes('/albums'))) || (uploadCount["allFromSameFolder"] && this.router.url.includes('/teamfolders/' + uploadCount["uploadedFolderKey"]))){
          this.universalService.showViewButton = true;
        }else{
          this.universalService.showViewButton = false;
        }
        this.universalService.showViewButton = false;
        var redirect = this.router.url.includes(uploadCount["uploadedFolderKey"]) ? false : true;
        var object = {
          "redirectUser": redirect,
          "selectObjects": redirect ? false : true,
          "redirectFolderKey": redirect ? uploadCount["uploadedFolderKey"] : USER_DETAILS["USER_DETAILS"]["rootFolderKey"],
          "locationOfUpload":uploadCount["locationOfUpload"],
          "uploadedFolderKey": uploadCount["uploadedFolderKey"] != ""  ? uploadCount["uploadedFolderKey"] : USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
        }
        AppEvents.toastMessageEvent.next({"action":"view","data":object})
        classRef.universalService.showToast(msg, "success");
        
        // if(this.universalService.isUploadFromRecentlyUploadedSection == false && this.router.url.includes("/home")) {//If upload was done on home page generic upload & not from panl
        //   AppEvents.emit(EventsList.RECENT_UPLOAD_UPDATE);
        // }
    },3000);
    
   
    // showSuccess(msg);

  }


  public showFailedNotificationMessage(uploadCount, successCount, failedCount) {
    let classRef = this;
    let itemStr = '';
    classRef.universalService.uploadStorageFullError = false;
    let destinationFolderName:string = '';
    classRef.universalService.uploadStorageFullError = false;
    if(uploadCount["uploadedFolderName"] != ""){
      destinationFolderName = " to '" + uploadCount["uploadedFolderName"] + "'";
    }
    const totalCount = successCount.total + failedCount.total;
    itemStr = totalCount > 1? 'items' : 'item' ;
    const msg = `${successCount.total} out of ${totalCount} ${itemStr} uploaded successfully ${destinationFolderName}.`
    if(successCount.total == 0){
      classRef.universalService.showToast(msg, "error");
      return;
    }
    this.universalService.showViewButton = true;
    this.universalService.showViewButton = false;
    setTimeout(()=>{
      classRef.universalService.showViewButton = (this.universalService.allowUpload && !classRef.universalService.fetchAllRecentFiles) ? true : false;
      if(uploadCount["allFromSameFolder"]){
        this.universalService.showViewButton = true;
      }else{
        this.universalService.showViewButton = false;
      }
      this.universalService.showViewButton = false;
      var redirect = this.router.url.includes(uploadCount["uploadedFolderKey"]) ? false : true;
      var object = {
        "redirectUser": redirect,
        "selectObjects": redirect ? false : true,
        "redirectFolderKey": redirect ? uploadCount["uploadedFolderKey"] : USER_DETAILS["USER_DETAILS"]["rootFolderKey"],
        "locationOfUpload":uploadCount["locationOfUpload"],
        "uploadedFolderKey": uploadCount["uploadedFolderKey"] != ""  ? uploadCount["uploadedFolderKey"] : USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
      }
      AppEvents.toastMessageEvent.next({"action":"view","data":object})
      classRef.universalService.showToast(msg, "success");
    },3000);
  }

  closeProgressBar(){
    let classRef = this;
    classRef.closeProgressBarInterval = setTimeout(function() {
      if(classRef.isUploadQueueEmpty() && classRef.getFailedUploadsFilesCount()==0){
        const event = new Event('click');
        let el = document.getElementById('closeProgress')
        if(el){
          el.dispatchEvent(event);
        }
        //document.getElementById('closeProgress').dispatchEvent(event);
        classRef.initAllUploadParams();
        
      }
    }, UPLOAD_CONS.PRGBAR_COLPSE_DELAY);
  }

  getFailedUploadsFilesCount() {
    let failedUploads = 0;
    this.uploadQueue.some(function (file)  {
      if (!file.uploadDone && file.isError) {
        failedUploads++;
      }
    })
    return failedUploads;
  }

  

  fetchNextIndex(currentPosition){
    var index = -1;
    let tempArray = this.uploadQueue.slice(currentPosition+1,this.uploadQueue.length)


    for (let file of tempArray) {
      if ((file.waiting && !file.isError) || (file.uploadDone && !file.uploadDone)) {
        index = file.index;
        return index;
      }
    }
    tempArray = this.uploadQueue.slice(0,currentPosition)
    for (let file of tempArray) {
      if ((file.waiting && !file.isError) || (file.uploadDone && !file.uploadDone)) {
        index = file.index;
        return index;
      }
    }
    return index;
    
  }

  public setUiEffects(obj) {
    
    var videoFormat = UPLOAD_CONS.FILE_FORMATS['VIDEO']
    var audioFormat = UPLOAD_CONS.FILE_FORMATS['AUDIO']
    var imgFormat = UPLOAD_CONS.FILE_FORMATS['IMG']
    var hasFolderInBunch = false;
    
    var name = obj.name;
    if (obj.isFile) {
      var ext = name.substring(name.lastIndexOf("."));
    }
    if (!obj.isFile) {
      obj.icon = 'NeueFolderFilled';
    } else if (obj.type.indexOf('audio') >= 0 || (obj.isFile && obj.type.length === 0 && audioFormat.includes(ext))) {
      obj.icon = 'NeueAudio';
    } else if (obj.type.indexOf('video') >= 0  || obj.type.indexOf('x-mpegurl') >= 0 || (obj.isFile && obj.type.length === 0 &&
      (videoFormat.includes(ext) ||
        (obj.name.toLowerCase().indexOf('.mkv') > 0 ||
          obj.name.toLowerCase().indexOf('.vob') > 0 ||
          obj.name.toLowerCase().indexOf('.asf') > 0)))) {
      obj.icon = 'NeuePlayFilled';
    } else if (obj.type.indexOf('image') >= 0 || (obj.isFile && obj.type.length === 0 && imgFormat.includes(ext))) {
      obj.icon = 'NeueImageFilled';
    } else if (obj.type.indexOf('word') >= 0) {
      obj.icon = 'NeueDocFilled';
    } else if (
      obj.type.indexOf('excel') >= 0 || obj.type.indexOf('vnd.ms-excel.sheet.binary.macroenabled.12') >= 0 ||
      obj.type.indexOf('vnd.ms-excel') >= 0 || obj.type.indexOf('vnd.openxmlformats-officedocument.spreadsheetml.sheet') >= 0) {
      obj.icon = 'NeueXLSFilled';
    } else if (obj.type.indexOf('pdf') >= 0) {
      obj.icon = 'NeuePDFFilled';
    } else if (obj.type.indexOf('presentation') >= 0 || obj.type.indexOf('powerpoint') >= 0) {
      obj.icon = 'NeuePPTFilled';
    } else if (obj.type.indexOf('plain') >= 0) {
      obj.icon = "NeueTXTFilled";
    } else if (obj.isFile && obj.type.length === 0) {
      obj.icon = 'NeueOtherFiles';
    } else {
      obj.icon = 'NeueOtherFiles';
    }

  }

  setFileProperties(file){
    let classRef = this;
    file.waiting = true;
    file.isFile = true;
    if (file.size < UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
      classRef.setSmallFilesProp(file);
    } else {
      classRef.setLargeFilesProp(file);
    }
  }

  public setSmallFilesProp(file) {  
    let classRef = this; 
    file.waiting = true;
    file.alreadyExists=false;
    file.isFile = true;
    file.isError = false;
    file.uploadStarted = false;
    file.preparingUpload = false;
    file.uploadDone = false;
    file.isSingleRetry = false;
    file.progress = 0;
    file.uploadedBytes = 0;
    file.transactionId = undefined;
    file.retryCount = 0;
    file.uploadByteTimeArray= [];
    file.timeToUpload = file.size / (1024 * 1024);
    file.subscriber = new Subscription();

    file.remainingBytes = file.size;
    file.remainingLargeSizeRead = 0;
    file.lastUploadRate = -1;
    file.lastReadingRate = 0;
    file.albumNotSupproted = false;
    if(this.universalService.isAlbumsView && !(file.type.includes("image/") ||  file.type.includes("video/"))){
      file.albumNotSupproted = true;
    }

    file.cancelUpload = function(){
      classRef.cancelSingleFileUpload(this);
    }
    file.retryUpload = function(){
      classRef.retrySingleFileUpload(this);
    }
  }

  public setLargeFilesProp (file) {
    let classRef = this;
    file.isError = false;
    file.uploadStarted = false;
    file.preparingUpload = false;
    file.uploadDone = false;
    file.alreadyExists = false;
    file.progress = 0;
    file.isSingleRetry = false;
    file.uploadedBytes = 0;
    file.transactionId = undefined;
    file.offset = 0;
    file.isFile = true;
    file.retryCount = 0;
    file.autoRetryFlag = false;
    file.spark = new SparkMD5.ArrayBuffer();
    file.timeToRead = undefined;
    file.remainingBytes = file.size;
    file.timeToUpload = file.size / (1024 * 1024);
    file.firstChunkReadTimeStamp = undefined;
    file.lastChunkReadTimeStamp = undefined;
    file.uploadByteTimeArray = [];
    file.hasher;
    
    file.remainingLargeSizeRead = file.size;
    file.largeSize = file.size;

    file.lastUploadRate = -1;
    file.lastReadingRate = -1;

    file.albumNotSupproted = false;

    file.uploadLargeByteMap=new Map();

    if(this.universalService.isAlbumsView && !(file.type.includes("image/") ||  file.type.includes("video/"))){
      file.albumNotSupproted = true;
    }
    file.cancelUpload= function(){
      classRef.cancelSingleFileUpload(this);
    }
    file.retryUpload= function(){
      classRef.retrySingleFileUpload(this);
    }
  }

  cancelSingleFileUpload(file){
    file.isCancelled  = true
    if(file.subscriptions!=undefined)
      file.subscriptions.unsubscribe(); 
    let classRef=this;
      let isUploading = file.uploadStarted 
      let isPreparingUpload = file.preparingUpload 
      if (file.isError == true) {
        return;
      }

      if (file.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT && file.preparingUpload) {
        file.fileReader.abort();
        file.firstChunkReadTimeStamp= undefined;
        file.lastChunkReadTimeStamp = undefined;
        file.preparingUpload = false;
        classRef.setLargeFilesProp(file);
      }else if (file.size < UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
        file.progress = 0;
        file.preparingUpload = false;
      }

      if(file.preparingUpload!=true && file.subscriber){
        file.subscriber.unsubscribe();
      }
      this.uploadCompleted = false;
      this.universalService.uploadCompleted = this.uploadCompleted;

      file.isError = true;
      file.uploadStarted = false;
      file.uploadDone = false;
      file.waiting = false;
      file.isRetryAll = false;

      classRef.addtoFailedUploadList(file)

      if (classRef.isMoreThanOneFileToRetry()) {
        classRef.isRetryAll = true;
        classRef.cancelAll = false;
      }

      if (!this.isAnyFileWaiting() && this.isUploadQueueEmpty()) {
        classRef.uploadCompleted = true;
        classRef.universalService.uploadCompleted = this.uploadCompleted;
      }
      if(isUploading || isPreparingUpload){
        classRef.uploadInprocess = false;
      }
      if(!this.uploadCompleted && !classRef.uploadInprocess)
        classRef.next(file.index);
  }
  retrySingleFileUpload(file){
      let classRef = this;
      file.isError=false;
      this.uploadCompleted = false;
      this.universalService.uploadCompleted = this.uploadCompleted;
      file.uploadStarted = false;
      file.waiting = true;
      file.uploadDone = false;
      file.isSingleRetry = true;
      file.canceledAllEvent = false;
      if (file.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
        file.timeToRead = 0;
        file.timeToUpload = 0;
        file.uploadByteTimeArray = [];
        file.firstChunkReadTimeStamp = undefined;
      }
      else if (file.size < UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
        file.uploadByteTimeArray = [];
      }
      
      for (var i = 0; i <= classRef.failedUploads.length - 1; i++) {
        if (classRef.failedUploads[i]['index'] == file['index']) {
          classRef.failedUploads.splice(i, 1);
        }
      }

      if (classRef.isMoreThanOneFileToRetry()) {
        classRef.isRetryAll = true;
        classRef.cancelAll = false;
      } else if (!classRef.isMoreThanOneFileToRetry()) {
        classRef.isRetryAll = false;
        classRef.cancelAll = true;
      } else if (!classRef.isAnyFileWaiting() && classRef.isUploadQueueEmpty()) {
        classRef.uploadCompleted = true;
        classRef.universalService.uploadCompleted = classRef.uploadCompleted;
        return;
      }     

      if(!classRef.uploadInprocess){
        classRef.startUpload(file.index)
      }
  }
  private setFolderProperties(folder){
    let classRef = this;
    if (!folder.uploadStarted && !folder.uploadDone && !folder.isFile) {
      folder.waiting = true;
      folder.isError = false;
      folder.uploadStarted = false;
      folder.preparingUpload = false;
      folder.uploadDone = false;
      folder.isSingleRetry = false;
      folder.progress = 0;
      folder.uploadedBytes = 0;
      folder.objectKey = undefined;
      folder.uploadDirectory = undefined;
      folder.uploadedFilesInFolder = 0;
      folder.filesCountInFolder = folder["uploadFromButtonClick"]?folder.totalFilesCount:0;
      folder.droppedFolderSize = folder["uploadFromButtonClick"]?folder.size:0;
      folder.failedFileUploadCount = 0;
      folder.failedFileUploadZeroSizeCount = 0;

      // folder.name = undefined;
      folder.uploadedFolderSize = 0;
      folder.folderType = "";
      folder.isFile = false;

      folder.largeSize = folder["uploadFromButtonClick"]?folder.largeFilesSize:0;
      folder.remainingLargeSizeRead = folder["uploadFromButtonClick"]?folder.largeFilesSize:0;
      
      folder.remainingLargeSizeUpload = folder["uploadFromButtonClick"]?folder.largeFilesSize:0;
      folder.remainingSmallSizeUpload = folder["uploadFromButtonClick"]?folder.smallFilesSize:0;
      
      folder.uploadFromButtonClick = folder["uploadFromButtonClick"]?true:false;

      folder.uploadByteTimeArray=[];
      folder.uploadLargeByteTimeArray=[];
      
      folder.uploadSmallByteMap=new Map();
      folder.uploadLargeByteMap=new Map();

      
      folder.lastUploadRate = -1;
      folder.lastReadingRate = -1;

      folder.cancelUpload= function(){
        classRef.cancelFolderUpload(this,false);
      }
      folder.retryUpload= function(uploadParams){
        classRef.retryFolderUpload(this, uploadParams);
      }
      
      folder.subscriptions= new Subscription();
    }

  }

  cancelFolderUpload(folder,isCancelAll){
    let classRef = this;
    let isUploadStarted = folder.uploadStarted
    if(folder.subscriptions != undefined)
      folder.subscriptions.unsubscribe(); 
    this.uploadFolderImpl.abortReadingOfAllFilesInFolder(); // this.abortReadingOfAllFilesInFolder();
   //this.updateFolderErrProps(ffile); //unsubscribing all request for that folder
    folder.isError = true;
    folder.uploadStarted = false;
    folder.uploadDone = false;
    folder.waiting = false;
    folder.isCancelled = true;

    this.addtoFailedUploadList(folder);
    if (classRef.isMoreThanOneFileToRetry()) {
      classRef.isRetryAll = true;
      classRef.cancelAll = false;
    }
  
    if (!this.isAnyFileWaiting() && this.isUploadQueueEmpty()) {
      this.uploadCompleted = true;
      classRef.universalService.uploadCompleted = this.uploadCompleted;
    }
    if(isUploadStarted){
      classRef.uploadInprocess = false;
    }

    if(!isCancelAll && !classRef.uploadInprocess){
      classRef.next(folder.index) ;
    }else if(isCancelAll){
      classRef.resetUploadParams()
    }
  }

  retryFolderUpload(folder,uploadParams){
    
  }

  
  public addtoFailedUploadList(obj) {
    let isAlreadyPresent: boolean = false;
    this.failedUploads.forEach(failedObject => {
      if (failedObject.index == obj.index) {
        isAlreadyPresent = true
      }
    });
    if (!isAlreadyPresent) {
      this.failedUploads.push(obj)
    }
  }

  countCalculation(obj, filesAndDirectories, pos) {
    var classRef = this;
    return new Promise(async (resolve, reject) => {
      await classRef.getFilesCountAndSize(obj, filesAndDirectories, resolve, reject)
      //resolve(pos);
    });
  }

  async getFilesCountAndSize(ffile, filesAndDirs, resolve, reject) {
    var self = this;
    ffile.folder = filesAndDirs;
    if (!ffile.isFile && !ffile.uploadStarted && !ffile.uploadDone) {
      var item = ffile.folder;
      if (item.isDirectory) {
        ffile.isFile = false;
        ffile.dirCountInFolder = 0;
        ffile.countcheck = 0;
        await self.readAllDirectoryEntries(item, '', ffile, resolve, reject);
      } else {
        ffile.isFile = true;
      }
    }
  }


  async readAllDirectoryEntries(item, path, ffile, resolve, reject) {
    var self = this;
    path = path || "";
    if (item.isFile) {// && self.notAllowedExt.indexOf(item["name"].toLowerCase()) == -1
      item.file(function (file) {
        ffile.countcheck = ffile.countcheck-1;
        if(self.notAllowedExt.indexOf(file["name"].toLowerCase()) == -1){
          ffile.droppedFolderSize = ffile.droppedFolderSize + file.size;
          if (file.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
            ffile.largeSize = ffile.largeSize + file.size;
            ffile.remainingLargeSizeRead = ffile.largeSize;
            ffile.remainingLargeSizeUpload = ffile.largeSize;
          } else {
            ffile.remainingSmallSizeUpload = ffile.remainingSmallSizeUpload + file.size;
          }
          ffile.filesCountInFolder = ffile.filesCountInFolder + 1;
          if (ffile.countcheck == 0) {
             resolve()
          }
        }
          
       
      });
        
    } else if (item.isDirectory) { ffile.dirCountInFolder = ffile.dirCountInFolder+1;
      if(path!='')
        ffile.countcheck = ffile.countcheck -1
      let entries = await this.getDirectoryEntries(item.createReader());
      ffile.countcheck = ffile.countcheck + entries.length;
      for (let i = 0; i < entries.length; i++) {
        await self.readAllDirectoryEntries(entries[i], path + item.name + "/", ffile, resolve, reject);
      }
      if (ffile.countcheck == 0) {
         resolve()
      }
    }
    // if (path == "") {
    //    resolve()
    // }
  }


  async getDirectoryEntries(dirReader) {
    let allEntries = [];
    let entries: [];
    entries = await this.readEntries(dirReader);
    while (entries.length > 0) {
      allEntries.push(...entries);
      entries = await this.readEntries(dirReader);
    }
    return allEntries;
  }

  async readEntries(dirReader): Promise<any> {
    return await new Promise((resolve, reject) => {
      dirReader.readEntries(resolve, reject)
    })
  }

  public resetFolderPropertiesAsPerUserSelectionOnDuplicateFolder(ffile){
    ffile.isError = false;
    ffile.uploadStarted = false;
    ffile.uploadDone = false;
    ffile.waiting = false;
    ffile.isCancelled = false;
  }

  public updateFolderPropertiesOnErr(ffile){
    ffile.isError = true;
    ffile.uploadStarted = false;
    ffile.uploadDone = true;
    ffile.waiting = false;
    ffile.isCancelled = true;
  }

  public isAnyFileWaiting() { 
    var isWaiting = false;
    this.uploadQueue.forEach(file => {
      if ((file.waiting && !file.isError) || (file.uploadDone && !file.uploadDone)) {
        isWaiting = true;
      }
    });

    return isWaiting;
  }

  public isUploadQueueEmpty() {
    var isQueueEmpty = true;
    this.uploadQueue.forEach(file => {
      if (file.waiting || file.preparingUpload || file.uploadStarted || file.errorPopUpWaiting) {
        isQueueEmpty = false;
      }
    });
    return isQueueEmpty;
  }

  public closeUploadProgressBar(){
    this.universalService.MarkNewObjArray = [];
    this.uploadStarted = false;
    this.initAllUploadParams();
    this.uploadInprocess = false;
    //this.clearCloseProgressBarInterval();
  }

  public uploadingCount() {
    if (this.uploadQueue == undefined || this.uploadQueue.length == 0) {
      return;
    }
    let uploading = 0;
    this.uploadQueue.some(function (file) {
      if (file.preparingUpload || file.uploadStarted || file.waiting) {
        uploading++;
      }
    });
    return uploading;
  }

  public isUploadOn() {
    if (this.uploadQueue == undefined || this.uploadQueue.length == 0) {
      return;
    }
    let classRef = this;
    var isUploadStart = false;
    classRef.uploadQueue.some(function (file) {
      if (classRef.universalService.isAlbumsView && !file.albumNotSupproted && (file.preparingUpload || file.uploadStarted || file.waiting)) {
        isUploadStart = true;
        return true;
      }else if (!classRef.universalService.isAlbumsView && (file.preparingUpload || file.uploadStarted || file.waiting)) {
        isUploadStart = true;
        return true;
      }
    });

    return isUploadStart;
  }

  public checkIfUploadQueueContainsOnlyFolders(){
    var containsOnlyFolders = true;
    this.uploadQueue.forEach(file => {
      if (this.universalService.isAlbumsView && file.isFile  && !file.albumNotSupproted  && !file.uploadDone) {
        containsOnlyFolders = false;
      }else if (!this.universalService.isAlbumsView && file.isFile && !file.uploadDone) {
        containsOnlyFolders = false;
      }
    });
    return containsOnlyFolders;
  }

  public isMoreThanOneFileToRetry() {
    var count = 0;
    this.uploadQueue.forEach(file => {
      if(this.universalService.isAlbumsView && !file.albumNotSupproted && file.isError){
        count += 1;
      }else if (file.isError) {
        count += 1;
      }
    });

    if (count > 0) return true;
    return false;
  }

  public uploadedCount() {
    if (this.uploadQueue == undefined || this.uploadQueue.length == 0) {
      return;
    }
    let uploaded = 0;
    this.uploadQueue.some(function (file) {
      if (file.uploadDone && !file.isError) {
        uploaded++;
      }
    });
    return uploaded;
  }
  removeFromFaileduploadArray(file){
    let classRef = this;
    const index = classRef.failedUploads.findIndex((item)=> {
      return item.index == file.index; 
    })
    if(index > -1) {
      classRef.failedUploads.splice(index, 1);
    }
  }

  cancelAllUpload(){
    let classRef = this;
    this.cancelAllFileUpload();// cancelAllUpload_uploadimpl();
    
    this.uploadQueue.forEach((file)=>{
      if (!file.uploadDone && !file.isFile) {
        classRef.cancelFolderUpload(file,true);
      }
    })
    this.uploadInprocess = false;
  }

  public cancelAllFileUpload(){
  
    let classRef=this;
    classRef.cancelAll = false;
    classRef.uploadCompleted = false;
    classRef.universalService.uploadCompleted = classRef.uploadCompleted;
    // classRef.commonSmallFileUploadRate = 0;
    // classRef.commonLargeFileUploadRate = 0;
    // classRef.smallUploadRateArray = [];
    // classRef.commonReadRate = -1;

    classRef.uploadQueue.forEach((file)=> {
      if(!file.isFile)
        return;
      if(file.preparingUpload!=true && file.subscriber){
        file.subscriber.unsubscribe();
      }

      if (file.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT && file.preparingUpload) {
        if (file.fileReader) {
          file.fileReader.abort();
          file.firstChunkReadTimeStamp= undefined;
          file.lastChunkReadTimeStamp = undefined;
        }
        file.preparingUpload = false;
      }

      if (!file.uploadDone && file.isFile) {
        file.isError = true;
        file.preparingUpload = false;
        file.uploadStarted = false;
        file.waiting = false;
        file.progress = 0;
        file.canceledAllEvent = true;
        classRef.addtoFailedUploadList(file);
      }
    });

    if (classRef.isMoreThanOneFileToRetry()) {
      classRef.isRetryAll = true;
    }
    if (!classRef.isAnyFileWaiting()) {
      classRef.uploadCompleted = true;
      classRef.universalService.uploadCompleted = classRef.uploadCompleted;
    }
  }

  public retryAllUpload(){
    let classRef=this;
    let index = -1;
    classRef.uploadInprocess = false;
    classRef.uploadCompleted = false;
    classRef.universalService.uploadCompleted = classRef.uploadCompleted;
    classRef.isRetryAll = false;
    classRef.cancelAll = true;
    //classRef.timeRemaining = "";

    var arrLen = classRef.failedUploads.length;
    for (var i = 0; i <= arrLen; i++) {
      if (!classRef.failedUploads || classRef.failedUploads.length == 0) {
        break;
      }

      var obj = classRef.failedUploads[0];
      if (obj.isFile) {
        classRef.failedUploads.splice(0, 1);
      }
    }

    classRef.uploadQueue.forEach((file, idx)=> {
      if (!file.uploadDone && file.isFile) {
        file.uploadStarted = false;
        file.progress = 0;
        file.isRetryAll = true;
        file.isSingleRetry = false;
        file.canceledAllEvent = false;
        file.uploadByteTimeArray = [];
        if(this.universalService.isAlbumsView && file.albumNotSupproted){
          obj.isError = true;
          obj.waiting = false;
        }else{
          if(index < 0)
            index = file.index;
          file.isError = false;
          file.waiting = true;
        }

      }
    });
    if(index>-1)
      this.startUpload(index)

  }

  public connectionDown(){
    let classRef = this;
    if (this.uploadQueue !== undefined) {
      if(classRef.cancelAll){
        return;
      }else if (classRef.isUploadOn()) {
        classRef.cancelAllUpload();
      }
    }
  }

  public connectionRestored(){
    let classRef = this;
    if (this.uploadQueue.length > 0) {
      //if (classRef.cancelAll == false) {
        classRef.retryAllUpload();
      //}
    }
  }

  clearCloseProgressBarInterval(){
    let classRef = this;   
    if(classRef.closeProgressBarInterval){
      clearTimeout(classRef.closeProgressBarInterval);
    }
  }

  gettimeLeftToFinishUpload(){
    return UploadQueueImpl.timeLeftToFinishUpload;
  }
}
